import type { AxiosRequestConfig } from "axios";

import { Get, Post } from "@repo/helpers";

export class BaseController {
	static GetFn(controller: string) {
		return function <T>(action: string, params: object | string = {}, config?: AxiosRequestConfig): Promise<T> {
			return Get<T>(controller, action, params, config);
		};
	}

	static PostFn(controller: string) {
		return function <T>(
			action: string,
			params: object | string = {},
			data?: object,
			config?: AxiosRequestConfig,
		): Promise<T> {
			return Post<T>(controller, action, params, data, config);
		};
	}
}
